import { atom } from 'jotai';
import { $CurrentGalleryArticle, $CurrentGallerySlide } from '.';
import { $IsMobileUser } from '~/utils/is-mobile-user';

export const $LabelSwitcherVisible = atom((get) => {
  const { galleryLabels } = get($CurrentGalleryArticle);
  const currentGallerySlide = get($CurrentGallerySlide);

  // interception
  const isMobileUser = get($IsMobileUser);
  if (isMobileUser && currentGallerySlide === 1) {
    return false;
  }

  const currentSlideLabels = galleryLabels.filter((g) => g.imageIndex === currentGallerySlide);

  return Boolean(currentSlideLabels.length);
});
